import { DialogConfirmation } from '@reapitform/common-ui'
import { useDeleteAgreement } from '../../api/documents/actions/delete-agreement'
import React from 'react'

interface IDeleteDraftProps {
  isOpen?: boolean
  onClose?: () => void
  onFinish?: (agreementIds: string[]) => void
  agreementId?: string[]
}

export const DeleteDraftModal: React.FC<IDeleteDraftProps> = ({ isOpen = false, onClose, onFinish, agreementId }) => {
  const { deleteAgreement, isLoading } = useDeleteAgreement()

  const confirmationMessage: string = React.useMemo(() => {
    if (!agreementId?.length) return ''
    const agreementLength: number = agreementId.length
    const isHaveMoreThan1: boolean = Boolean(agreementLength && agreementId.length > 1)

    if (isHaveMoreThan1)
      return `You have selected ${agreementLength} agreements. This action will permanently delete these agreements and cannot be undone.`
    return 'This action will permanently delete the agreement and cannot be undone.'
  }, [agreementId?.length])

  if (!agreementId || !agreementId.length) return

  const handleDelete = async () => {
    await deleteAgreement({ iDs: agreementId })
    onFinish?.(agreementId)
    onClose?.()
  }

  return (
    <DialogConfirmation
      message={confirmationMessage}
      title="Delete Draft"
      isLoading={isLoading}
      isOpen={isOpen}
      onCancel={() => onClose?.()}
      onClose={() => onClose?.()}
      onConfirm={handleDelete}
      confirmButtonText="Delete"
      intent="danger"
    />
  )
}
